module.exports = __webpack_public_path__ + "static/media/user_icon.17e7bfc2.svg";